
import objectPath from 'object-path'

const getters = {
  isLoading: state => state.isLoading,
  isLoadingMore: state => state.isLoadingMore,
  isFiltering: state => state.isFiltering,
  isFiltersApplied: state => state.isFiltersApplied,
  isFavoriteLoading: state => state.isFavoriteLoading,
  isEmptyFilteringResults: state => state.emptyFilteringResults,
  isDeleteMode: state => state.deleteMode,
  getErrors: state => ({
    loadingIsFailed: state.loadingIsFailed,
    errorsList: state.errors
  }),
  getCollection: state => state.collection,
  getCollectionFilters: state => state.collectionFilters,
  getViewType: state => state.viewType,
  showAgencyPrice: state => state.agencyPrice,
  getSelectedItems: state => state.collection
    .filter(hotel => hotel.isSelected)
    .map(hotel => hotel.favoriteId),
  getFields: state => ({
    ...state.form,
    filters: state.filters
  }),
  getField: state => target => objectPath.get(state, target),
  getPagination: state => state.pagination
}

export default getters